import {onFind} from "@elements/init-modules-in-scope";
import {on, findIn, trigger} from "@elements/dom-utils";

export function init() {
    onFind('.js-form-validation', function (baseElement) {
        on('form-validation.submit' , () => {
            baseElement.submit();
            trigger('submit', baseElement);
        }, baseElement);
    });
}
